import imageFragmentRawString from '../ImageFragment.graphql'

export const imageFragmentString = imageFragmentRawString

export type ImageFragment = {
  id: string
  url: string
  smallThumb: string
  width: number
  height: number
}

export const isImageFragment = (fragment: any): fragment is ImageFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.url === 'string' &&
  typeof fragment.smallThumb === 'string' &&
  typeof fragment.width === 'number' &&
  typeof fragment.height === 'number'
